import React from 'react';
import { ClassAssembly10E2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly10E2026 />;
  };
  
  export default ClassAssemblyPage;